import {
  faChevronDown,
  faChevronUp,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCombobox } from "downshift";
import React, { useState } from "react";

export default function CreatePatientBreedDropdown({
  items,
  onChange,
  value,
}) {
  const [inputItems, setInputItems] = useState(items);
  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    getInputProps,
    getComboboxProps,
    highlightedIndex,
    getItemProps,
  } = useCombobox({
    onIsOpenChange: () => {
      setInputItems(items);
    },
    onSelectedItemChange: ({ inputValue }) => {
      onChange(inputValue);
    },
    items: inputItems,
    onInputValueChange: ({ inputValue }) => {
      setInputItems(
        items.filter((item) =>
          item.toLowerCase().includes(inputValue.toLowerCase()),
        ),
      );
      onChange(inputValue);
    },
  });

  return (
    <div className="relative w-full">
      <div
        {...getComboboxProps()}
        className={`flex items-center rounded-standard bg-input transition-all ${
          isOpen
            ? "border-2 border-brand shadow-[0px_0px_10px_0px_var(--shadow-focus)]"
            : "shadow-[0px_0px_10px_0px_var(--shadow-primary)] hover:shadow-[0px_0px_10px_0px_var(--shadow-focus)]"
        }`}
      >
        <input
          name="breed"
          {...getInputProps({
            value,
            placeholder: "Select or type in breed...",
          })}
          className="flex-1 min-w-0 h-10 px-md py-sm bg-transparent text-sm text-primary placeholder:text-placeholder outline-none"
          data-testid="pBreedInput"
        />
        <button
          type="button"
          className="px-md shrink-0 focus:outline-hidden"
          {...getToggleButtonProps()}
          aria-label="toggle menu"
          data-testid="pBreedDropdown"
        >
          <FontAwesomeIcon
            icon={isOpen ? faChevronUp : faChevronDown}
            className="text-brand text-xs"
          />
        </button>
      </div>
      <ul
        {...getMenuProps()}
        className={
          isOpen
            ? "absolute z-20 w-full mt-2 bg-input rounded-standard shadow-[0px_0px_10px_0px_var(--shadow-primary)] overflow-hidden max-h-44 overflow-y-auto"
            : "hidden"
        }
      >
        {inputItems.map((item, index) => (
          <li
            className={`h-10 px-md py-sm text-sm cursor-pointer text-primary flex items-center ${
              highlightedIndex === index
                ? "bg-secondary"
                : "bg-input hover:bg-secondary"
            }`}
            key={`${item}${index}`}
            {...getItemProps({ item, index })}
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
